import React from "react";
import ProjectLogo from "../ProjectLogo/ProjectLogo";
import "./fields.css";

// Building blocks for the registration forms. Choices are real radio inputs
// (visually styled as chips/cards), so they submit, validate (`required`) and
// fire the forms' existing `handleChange` exactly like the <select>s they
// replace: event.target.name / event.target.value are the same.

const idFor = (name, value) => `${name}-${String(value).replace(/[^a-z0-9]+/gi, "-")}`;

// A titled, numbered group of fields; children lay out on a 2-column grid
// on wider screens (use `reg-field--full` to span).
export const FormSection = ({ step, title, hint, children }) => (
  <section className="reg-section" aria-label={title}>
    <header className="reg-section-head">
      <span className="reg-step" aria-hidden="true">
        {step}
      </span>
      <span className="reg-section-text">
        <strong>{title}</strong>
        {hint && <small>{hint}</small>}
      </span>
    </header>
    <div className="reg-grid">{children}</div>
  </section>
);

// Tappable single-choice chips (variant "segmented" for a Yes/No toggle)
export const ChoiceChips = ({ name, value, options, onChange, required = false, variant = "chips", label }) => (
  <div className={`reg-choices reg-choices--${variant}`} role="radiogroup" aria-label={label}>
    {options.map((option) => {
      const id = idFor(name, option.value);
      const checked = value === option.value;
      return (
        <label key={option.value} htmlFor={id} className={`reg-choice${checked ? " is-checked" : ""}`}>
          <input
            id={id}
            type="radio"
            name={name}
            value={option.value}
            checked={checked}
            onChange={onChange}
            required={required}
          />
          <span>{option.label}</span>
        </label>
      );
    })}
  </div>
);

// Place of Visit as cards with each project's monogram logo
export const ProjectCards = ({ name, value, projects, onChange, required = false }) => (
  <div className="reg-projects" role="radiogroup" aria-label="Place of visit">
    {projects.map((project) => {
      const id = idFor(name, project.name);
      const checked = value === project.name;
      return (
        <label key={project.name} htmlFor={id} className={`reg-project${checked ? " is-checked" : ""}`}>
          <input
            id={id}
            type="radio"
            name={name}
            value={project.name}
            checked={checked}
            onChange={onChange}
            required={required}
          />
          <ProjectLogo name={project.name} size={34} />
          <span className="reg-project-name">{project.name}</span>
          <span className="reg-project-check" aria-hidden="true">
            ✓
          </span>
        </label>
      );
    })}
  </div>
);
